import { useState } from 'react'
import EntityAutocomplete from '../../components/EntityAutocomplete'
import Icon from '../../components/Icon'
import * as clientesApi from '../../api/clientes'

const iniciales = (nombre) => (nombre || '?').split(/\s+/).slice(0, 2).map((w) => w[0]).join('').toUpperCase()

// ① Cliente — muestra el cliente seleccionado (card) o un buscador para elegirlo.
export default function ClienteCard({ vm, submitted }) {
  const cliente = vm.comprobante.cliente
  const [picking, setPicking] = useState(false)

  const onPick = (c) => { vm.changeCliente(c); setPicking(false) }

  if (!cliente || picking) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <label className="field-label">Buscar cliente (nombre, RUC o código)</label>
        <EntityAutocomplete
          label=""
          value={picking ? null : cliente}
          onChange={onPick}
          fetcher={(s) => clientesApi.buscarClientes(s)}
          getOptionLabel={(o) => o?.nombre || o?.nombreFantasia || ''}
          minChars={3}
          error={submitted && !cliente}
        />
        {submitted && !cliente && <span style={{ color: 'var(--danger)', fontSize: 11.5 }}>Seleccioná un cliente.</span>}
      </div>
    )
  }

  const suc = vm.comprobante.sucursalCliente
  return (
    <div className="cliente-selected">
      <div className="cliente-avatar">{iniciales(cliente.nombre)}</div>
      <div className="cliente-meta">
        <div className="nm">{cliente.nombre || cliente.nombreFantasia}</div>
        <div className="sub">
          {cliente.numero ? <>RUC <strong>{cliente.numero}</strong></> : 'Sin RUC'}
          {suc?.descripcion ? <> · Sucursal <strong>{suc.descripcion}</strong></> : ''}
          {cliente.ciudad?.descripcion ? <> · {cliente.ciudad.descripcion}</> : ''}
        </div>
        <div className="sub" style={{ marginTop: 4, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {cliente.tipoOperacion?.codigo && <span className="badge-soft">{cliente.tipoOperacion.codigo}</span>}
          {vm.comprobante.listaPrecioVenta?.descripcion && <span className="badge-soft">Lista {vm.comprobante.listaPrecioVenta.descripcion}</span>}
          {cliente.exoneradoIva && <span className="badge-soft warn">Exonerado IVA</span>}
        </div>
      </div>
      <button className="btn btn-sm" type="button" onClick={() => setPicking(true)}>
        <Icon name="edit" size={13} /> Cambiar
      </button>
    </div>
  )
}
